/* Editorial mobile drawer
   1. Category accordion toggle (animation is CSS: grid-template-rows 0fr -> 1fr). Multi-open by design.
   2. "Peek" nudge on the card row EVERY time the drawer opens, so the scroller reveals itself.
      Skipped under prefers-reduced-motion; cancelled the moment the user touches the row. */
(function () {
  function bindAccordion(root) {
    root.querySelectorAll('.edrawer__cat-btn[aria-expanded]').forEach(function (btn) {
      if (btn.dataset.edrawerBound) return;
      btn.dataset.edrawerBound = '1';
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        var row = btn.closest('.edrawer__cat');
        if (row) row.classList.toggle('is-open', !open);
      });
    });
  }

  var NUDGE_PX = 44;
  var NUDGE_MS = 450;
  var NUDGE_DELAY_MS = 950;   /* after the card row has finished its entrance stagger */

  function easeInOut(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }

  function nudge(track) {
    if (!track) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var room = track.scrollWidth - track.clientWidth - track.scrollLeft;
    if (room < NUDGE_PX + 10) return;
    if (track.dataset.nudging) return;
    track.dataset.nudging = '1';

    var cancelled = false;
    var cancel = function () { cancelled = true; delete track.dataset.nudging; };
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (type) {
      track.addEventListener(type, cancel, { once: true, passive: true });
    });

    var from = track.scrollLeft;
    function run(a, b, done) {
      var start = null;
      function step(ts) {
        if (cancelled) return;
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / NUDGE_MS);
        track.scrollLeft = a + (b - a) * easeInOut(p);
        if (p < 1) requestAnimationFrame(step); else if (done) done();
      }
      requestAnimationFrame(step);
    }
    run(from, from + NUDGE_PX, function () {
      setTimeout(function () { run(from + NUDGE_PX, from, function () { delete track.dataset.nudging; }); }, 180);
    });
  }

  function watchDrawer(root) {
    var drawer = root.querySelector ? root.querySelector('header-drawer') : null;
    if (!drawer || drawer.dataset.edrawerWatched) return;
    var details = drawer.querySelector('details');
    if (!details) return;
    drawer.dataset.edrawerWatched = '1';
    var timer = null;
    var wasOpening = false;
    // While the drawer is open, hide the PDP sticky Add-to-Cart bar and chat float so
    // taps on the footer (login / social) don't fall through to them.
    function overlayGuards(hide) {
      document.querySelectorAll('.product-sticky-cart, [id^="chat-popup"]').forEach(function (el) {
        el.style.visibility = hide ? 'hidden' : '';
        el.style.pointerEvents = hide ? 'none' : '';
      });
    }
    new MutationObserver(function () {
      var opening = details.classList.contains('menu-opening');
      overlayGuards(opening);
      if (opening && !wasOpening) {
        timer = setTimeout(function () { timer = null; nudge(drawer.querySelector('.edrawer__cards')); }, NUDGE_DELAY_MS);
      } else if (!opening && timer) {
        clearTimeout(timer); timer = null;
      }
      wasOpening = opening;
    }).observe(details, { attributes: true, attributeFilter: ['class', 'open'] });
  }

  function init(root) { bindAccordion(root); watchDrawer(root === document ? document : root); }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
